export default {
  id: '',
  code: '',
  image: '',
  name: '',
  description: '',
  category: '',
  categoryId: '',
  quantity: '',
  price: '',
  branchCode: '',
  isTank: '',
  isDeleted: '',
  updatedBy: '',
  timestamp: '',
  newPrice: '',
};
